import { setLocale } from 'yup'

setLocale({
  mixed: {
    required: 'form.validation.required',
  },
  number: {
    min: ({ min }) => ({ key: 'form.validation.number.min', values: { min } }),
    max: ({ max }) => ({ key: 'form.validation.number.max', values: { max } }),
    integer: () => ({ key: 'form.validation.number.integer' }),
  },
})
